import axios from "axios";
import { API } from "@/App";

class CRMImportService {
  async importRepreneur(userData) {
    return this.callImportEndpoint(`${API}/crm-import/repreneurs`, userData);
  }

  async importCedant(userData) {
    return this.callImportEndpoint(`${API}/crm-import/cedants`, userData);
  }

  async importOpportunity(opportunityData) {
    return this.callImportEndpoint(`${API}/crm-import/opportunites`, opportunityData);
  }

  async callImportEndpoint(endpoint, data) {
    const token = localStorage.getItem("admin_token");
    const headers = token ? { Authorization: `Bearer ${token}` } : {};

    try {
      const response = await axios.post(
        endpoint,
        { items: data },
        { headers }
      );
      return {
        success: response.data.success,
        imported_count: response.data.imported_count,
        failed_count: response.data.failed_count,
        details: response.data.details,
      };
    } catch (error) {
      console.error("CRM Import error:", error);
      throw error;
    }
  }
}

export const crmImport = new CRMImportService();
